import React from "react";
import LegalMarkdownPage from "./LegalMarkdownPage";

import moderationEnglish from "../docs/moderation-policy/moderation.en.md";
import moderationFrench from "../docs/moderation-policy/moderation.fr.md";
import moderationArabic from "../docs/moderation-policy/moderation.ar.md";

import "../styles/LegalPages.css";

const moderationDocuments = {
  en: moderationEnglish,
  fr: moderationFrench,
  ar: moderationArabic,
  es: moderationEnglish, // no Spanish market yet, English reference version
  it: moderationEnglish, // no Italian market yet, English reference version
};

const ModerationPolicy = () => {
  return (
    <LegalMarkdownPage
      documents={moderationDocuments}
      containerClassName="legal-page-container"
      headingClassName="legal-page-heading"
      errorMessage="The Moderation Policy could not be loaded."
    />
  );
};

export default ModerationPolicy;
